import React, { useState } from "react";

import {
  Root,
  Container,
  TextContainer,
  HeadlineImage,
  HeadlineText,
  Legal,
  ImagesContainer,
  Content,
} from "./Main.style";

import headlineSrc from "../../assets/headline.svg";

import { ModalEntry } from "../ModalEntry/ModalEntry";
import { ModalRules } from "../../ModalRules/ModalRules";
import { Button } from "../../Button/Button";

export const Main = () => {
  const [entryShow, setEntryShow] = useState(false);
  const [rulesShow, setRulesShow] = useState(false);

  return (
    <Root>
      <Content>
        <Container>
          <TextContainer>
            <HeadlineImage
              src={headlineSrc}
              alt="C'mon & Celebrate / National Moonshine Week"
            />
            <HeadlineText>
              enter for a chance to{" "}
              <span>
                win
                <br />a vip trip to nashville
              </span>
            </HeadlineText>
            <Button type="button" onClick={() => setEntryShow(true)}>
              enter for a chance to win
            </Button>
            <Legal>
              Click to review the sweepstakes official{" "}
              <button onClick={() => setRulesShow(true)} type="button">
                rules and regs
              </button>
              .
            </Legal>
          </TextContainer>

          <ImagesContainer />
        </Container>
      </Content>

      {entryShow && <ModalEntry onClose={() => setEntryShow(false)} />}

      {rulesShow && <ModalRules onClose={() => setRulesShow(false)} />}
    </Root>
  );
};
